export const preventCharEnter = {
  methods: {
    /**
     * @description Prevent user to enter "-", "0" as leading zero, "e" and "+" into <input type="number" />
     * @return {boolean}
     */
    MX_preventCharInput (e) {
      if (e.key === "-" || e.key === "+" || e.target.value === '0' || e.key === 'e') {
        e.preventDefault();
        return false;
      }
    }
  }
};
